import { PlusIcon } from 'assets/icons';
import cn from 'classnames';
import React, { RefObject, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Tabs from 'shared/components/tabs/tabs';
import { BONUS_BALANCE, MAIN_BALANCE, SectionNavigation } from 'shared/constants/common';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';
import { State } from 'shared/interface';
import BalanceCount from '../BalanceCount';
import './styles.scss';

interface Props {
	isUser: boolean;
	isMobile?: boolean;
	handleAddFundsButton?: any;
	headerBalanceRef: RefObject<HTMLDivElement>;
	bonusBalance: number;
	mainBalance: number;
	setShowBalanceBar: React.Dispatch<SetStateAction<boolean>>;
	showBalanceBar?: boolean;
	totalBalance?: number;
	handleTabChange?: any;
}

const HeaderBalance: React.FC<Props> = (props) => {
	const { isUser, isMobile, handleAddFundsButton, headerBalanceRef, mainBalance, bonusBalance, showBalanceBar, totalBalance, handleTabChange } =
		props;

	const { t } = useTranslation();
	const selectedBalanceType = useSelector<State, string>((state) => state.cpPanel.balanceData.selectedBalanceType);
	const { isViewActive, isMainView } = useSectionNavigation();

	const tabs = [
		{
			label: (
				<>
					<div className={'font-size--10 font--medium line-height--16'}>{t('mainBalance')}</div>
					<div
						className={`font-size--default line-height--16 font--bold truncate--text ${
							mainBalance && mainBalance.toFixed(2).length > 7 ? 'font-size--12' : ''
						}`}
					>
						{t('Common_currency', { val: mainBalance || 0 })}
					</div>
				</>
			),
			value: MAIN_BALANCE,
		},
		{
			label: (
				<>
					<div className={'font-size--10 font--medium line-height--16'}>{t('bonusBalance')}</div>
					<div
						className={`font-size--default line-height--16 font--bold truncate--text ${
							bonusBalance && bonusBalance.toFixed(2).length > 7 ? 'font-size--12' : ''
						}`}
					>
						{t('Common_currency', { val: bonusBalance || 0 })}
					</div>
				</>
			),
			value: BONUS_BALANCE,
		},
	];

	return (
		<div ref={headerBalanceRef} className="headerBalance" onClick={handleAddFundsButton}>
			<div className="headerBalance__wrapper">
				<span className="headerBalance__add">
					<PlusIcon />
				</span>
				<div className="headerBalance__info">
					<div className="header-balance">
						<BalanceCount balance={totalBalance} className={cn({ headerBalance__autoWidth: bonusBalance !== 0 })} />
					</div>
				</div>
				{isUser && showBalanceBar && (isMainView() || isViewActive(SectionNavigation.COUPON)) && (
					<Tabs
						activeTab={selectedBalanceType}
						handleTabChange={handleTabChange}
						tabs={tabs}
						className={`${!isMobile && 'header-balance-tabs-desktop'} header-balance-tabs text--primary`}
					/>
				)}
			</div>
		</div>
	);
};

export default HeaderBalance;
